import type { PromotionPopupConfig } from '../popups/store'

export function initialPopupConfig(data: PromotionPopupConfig) {
  return { open: false, ...data }
}
